import React from 'react';
import { X as CloseIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-179">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto" data-id="element-180">
        <div className="flex justify-between items-center border-b p-4" data-id="element-181">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-182">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-183">
            <CloseIcon size={20} data-id="element-184" />
          </button>
        </div>
        <div className="p-6" data-id="element-185">{children}</div>
      </div>
    </div>;
};
export default Modal;